import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { setStatus("error"); return; }

    const poll = async () => {
      if (attempts.current >= 10) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("success"); refresh(); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background mg-radial p-6">
      <div className="max-w-md w-full text-center p-10 rounded-3xl border border-border bg-card mg-fade-up" data-testid="payment-result">
        {status === "checking" && (<><Loader2 size={56} className="mx-auto text-primary animate-spin mb-4" /><h1 className="font-display text-2xl font-bold">Validation du paiement…</h1><p className="text-muted-foreground mt-2">Un instant, nous confirmons votre abonnement.</p></>)}
        {status === "success" && (<><CheckCircle2 size={56} className="mx-auto text-emerald-500 mb-4" /><h1 className="font-display text-2xl font-bold">Paiement réussi ! 🎉</h1><p className="text-muted-foreground mt-2">Votre abonnement est actif et vos crédits IA ont été ajoutés.</p><Button onClick={() => navigate("/dashboard")} className="mt-6 rounded-xl bg-gradient-to-r from-indigo-500 to-cyan-500 text-white border-0" data-testid="goto-dashboard-btn">Accéder au tableau de bord</Button></>)}
        {(status === "error" || status === "timeout") && (<><XCircle size={56} className="mx-auto text-destructive mb-4" /><h1 className="font-display text-2xl font-bold">Paiement non confirmé</h1><p className="text-muted-foreground mt-2">{status === "timeout" ? "La confirmation prend plus de temps que prévu." : "Une erreur est survenue."}</p><Button onClick={() => navigate("/billing")} variant="outline" className="mt-6 rounded-xl">Retour à la facturation</Button></>)}
      </div>
    </div>
  );
}
